import { useMemo } from 'react'

export const RankChange: React.FC<{
  rankChange: number
}> = ({ rankChange }) => {
  const rankComp = useMemo(() => {
    if (rankChange > 0) {
      return (
        <div className="flex items-center justify-center px-4 py-1 text-xs text-error rounded-[40px] bg-[rgba(239,70,111,0.16)]">
          <div className="flex items-center">
            <i className="border-t-[6px] border-b-[6px] border-l-[5px] border-r-[5px] border-transparent border-b-error transform -translate-y-[30%]"></i>
            <i className="ml-[2px]">{rankChange}</i>
          </div>{' '}
          <div className="ml-2">比昨天上升&nbsp;{rankChange}&nbsp;名</div>
        </div>
      )
    } else if (rankChange < 0) {
      return (
        <div className="flex items-center justify-center px-4 py-1 text-xs text-success rounded-[40px] bg-[rgba(69,178,107,0.16)]">
          <div className="flex items-center">
            <i className="border-t-[6px] border-b-[6px] border-l-[5px] border-r-[5px] border-transparent border-t-success transform translate-y-[30%]"></i>
            <i className="ml-[2px]">{-rankChange}</i>
          </div>{' '}
          <div className="ml-2">比昨天下降&nbsp;{-rankChange}&nbsp;名</div>
        </div>
      )
    } else {
      return (
        <div className="flex items-center justify-center px-4 py-1 text-xs text-neutral-800 rounded-[40px] bg-[rgba(177,181,195,0.16)]">
          <div className="flex items-center">-</div>{' '}
          <div className="ml-2">与昨天相同</div>
        </div>
      )
    }
  }, [rankChange])

  return <>{rankComp} </>
}
